export const emptyPreferences = {
  location: {},
  homeType: {},
  lot: {},
  exterior: {},
  interior: {},
  lifestyle: {},
  accessibility: {},
  notes: {
    dealBreakers: "",
    mustHaves: "",
    householdNeeds: "",
    priorities: "",
    specialNotes: "",
    attachments: [],
  },
  pageNotes: {},
  tipsAcknowledged: false,
  transactionChecklist: {},
};

export const emptyBuyer = {
  id: "",
  name: "",
  email: "",
  phone: "",
  agentId: "",
  preferences: { ...emptyPreferences },
  status: "active",
};

export const initialBuyerState = {
  current: { ...emptyBuyer },
  list: [],
};

export function buyerReducer(state = initialBuyerState, action) {
  switch (action.type) {
    case "SET_BUYER":
      return { ...state, current: { ...emptyBuyer, ...action.payload } };
    case "SET_BUYERS":
      return { ...state, list: action.payload || [] };
    case "UPDATE_BUYER_PROFILE":
      return {
        ...state,
        current: { ...state.current, ...action.payload },
      };
    case "UPDATE_PREFERENCES":
      return {
        ...state,
        current: {
          ...state.current,
          preferences: {
            ...state.current.preferences,
            ...action.payload,
          },
        },
      };
    case "RESET_BUYER":
      return { ...state, current: { ...emptyBuyer } };
    default:
      return state;
  }
}
